import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import sweetVariations from './sweet-variations';
import dealerFiltering from './dealer-filtering';

jQuery(($) => {
  /**
   * Toggle circle menu open
   * Clone main menu into circle menu
   */
  const circleMenuWrapper = $('#circle-menu-wrapper');
  $('body').on('click', '#circle-menu-open', () => {
    const windowWidth = $(window).width();

    $('body').toggleClass('menu-open');

    if (windowWidth <= 766) {
      if ($('body').hasClass('menu-open')) {
        // Disable scrolling other elements
        disableBodyScroll(circleMenuWrapper);

        // Clone main menu into circle menu
        $('#main-menu-wrapper').clone().addClass('circle-menu-clone').appendTo(circleMenuWrapper);
      } else {
        // Remove cloned element
        $('.circle-menu-clone').remove();

        // Re-enable scrolling
        enableBodyScroll(circleMenuWrapper);
      }
    }
  });

  /**
   * WooCommerce notices closer / Emptying notice wrapper
   */
  $(document).on('click', '#notice-closer', (event) => {
    event.preventDefault();
    $('.woocommerce-notices-wrapper').empty();
  });

  /**
   * Copy background width class to MCB module section
   */
  $('.module .background-width').each((index, element) => {
    if ($(element).hasClass('background-fullwidth')) {
      $(element).closest('.module').addClass('stretch-background');
    }
  });

  /**
   * Scroll to element module parent on anchor button click
   */
  $('body').on('click', 'button.anchor-scroll', (event) => {
    const anchorId = event.target.dataset.anchor;
    if (anchorId && anchorId.length) {
      const parentModule = $(anchorId).closest('.module');
      const offsetTop = $(parentModule).offset().top;
      $('html, body').stop().animate({ scrollTop: offsetTop }, 500);
    }
  });
});

/**
 * Initialize sweetVariations
 */
sweetVariations();

/**
 * Initialize
 */
dealerFiltering();
